<template>
  <div>
    <el-form
      ref="searchForm"
      :model="searchInfo"
      :inline="true"
      :label-position="position"
    >
      <el-form-item>
        <el-input
          v-model="searchInfo.phone"
          placeholder="手机号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchInfo.name"
          placeholder="用户"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchInfo.openid"
          placeholder="openid"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          plain
          size="medium"
          @click="handlerSearch"
          icon="fa fa-search"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-row>
      <div class="avue-crud__menu">
        <div class="avue-crud__left">
          <button
            type="button"
            class="el-button filter-item el-button--primary el-button--mini"
            @click="handlerAddNew"
          >
            <i class="fa fa-plus"></i>
            <span>新增</span>
          </button>
        </div>
        <div class="avue-crud__right">
          <button
            type="button"
            class="el-button el-tooltip el-button--default el-button--small is-circle"
            aria-describedby="el-tooltip-2497"
            tabindex="0"
            title="刷新"
            @click="handlerRefresh"
          >
            <i class="el-icon-refresh"></i>
          </button>
        </div>
      </div>
      <el-col :xs="10">
        <el-table
          style="width: 100%;"
          ref="postListRef"
          :data="tableData"
          border
          :fit="true"
          :header-cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column
            prop="name"
            label="用户"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          />
          <el-table-column
            prop="phone"
            label="手机号"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          />
          <el-table-column
            prop="openid"
            label="openid"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          />
          <el-table-column
            prop="unionid"
            label="unionid"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          />
          <el-table-column
            prop="engineerId"
            label="工程师"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          />
          <el-table-column
            prop="payFlag"
            label="是否需要支付"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.payFlag == "0" ? "否" : "是" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="craftsmanType"
            label="手艺人类型"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              {{ getCraftsmanType(scope.row.craftsmanType) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="memo"
            label="备注"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          />
          <el-table-column
            label="操作"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <el-button size="mini" @click="handlerEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handlerDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          align="left"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchInfo.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="searchInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="Number(searchInfo.total)"
        ></el-pagination>
      </el-col>
    </el-row>
    <BusinessUserEdit ref="edit" @close="handlerRefresh"></BusinessUserEdit>
  </div>
</template>
<script>
import BusinessUserEdit from "./module/index.vue";
import { businessUserQuery, businessUserDelete } from "../../../api/api";
import { hideLoading, showLoading } from "../../../components/loading/loading";
export default {
  name: "BusinessUserList",
  components: {
    BusinessUserEdit
  },
  computed: {
    getCraftsmanType() {
      return function (val) {
        if (val === '0') {
          return '金牌手艺人'
        } else if (val === '5') {
          return '爱回收手艺人'
        }else if (val === '7') {
          return '爱回收保险手艺人'
        }
      }
    }
  },
  data() {
    return {
      //检索
      searchInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      },
      craftsmanType: [
        { label: "金牌手艺人", value: "0" },
        { label: "爱回收手艺人", value: "5" },
        { label: "爱回收保险手艺人", value: "7" }
      ],
      tableData: [],
      position: "left"
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      let _self = this;
      let params = _self.getQueryParams();
      showLoading();
      businessUserQuery(params)
        .then(res => {
          if (res.data.status == 100) {
            _self.tableData = res.data.results.list;
            _self.searchInfo.total = res.data.results.total;
          }
        })
        .finally(() => {
          hideLoading();
        });
    },
    getQueryParams() {
      const sqp = {};
      const param = Object.assign(sqp, this.searchInfo);
      param.startRow = param.pageNum;
      param.pageNum = undefined;
      return this.filterObj(param);
    },
    handlerSearch() {
      this.searchInfo.pageNum = 1;
      this.onLoad();
    },
    handleSizeChange(pageSize) {
      this.searchInfo.pageSize = pageSize;
      this.onLoad();
    },
    handleCurrentChange(pageNum) {
      this.searchInfo.pageNum = pageNum;
      this.onLoad();
    },
    handlerRefresh() {
      this.searchInfo.pageNum = 1;
      this.onLoad();
    },
    handlerAddNew() {
      this.$refs.edit.open("add", null);
    },
    handlerEdit(data) {
      this.$refs.edit.open("update", data);
    },
    handlerDelete(data) {
      const _self = this;
      this.$confirm("是否删除当前信息", "提示", { type: "warning" })
        .then(() => {
          showLoading();
          businessUserDelete({ id: data.id })
            .then(res => {
              if (res.data.status == 100) {
                _self.onLoad();
              } else {
                _self.$message.warning(res.data.message);
              }
            })
            .finally(() => {
              hideLoading();
            });
        })
        .catch(() => {});
    },
    filterObj(obj) {
      if (!(typeof obj == "object")) {
        return;
      }

      for (const key in obj) {
        if (
          //eslint-disable-next-line
          obj.hasOwnProperty(key) &&
          (obj[key] == null || obj[key] == undefined || obj[key] === "")
        ) {
          delete obj[key];
        }
      }
      return obj;
    }
  }
};
</script>
<style scoped>
.avue-crud__menu {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  position: relative;
  width: 100%;
  min-height: 40px;
  height: auto;
  overflow: hidden;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// index.vue?77983416